import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import { ReportState } from '~/shared';

const StyledContainer = styled.div`
	position: relative;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	overflow: hidden;
`;

const StyledHeadContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 60px;
	padding: 0 20px;
	background: rgba(255, 255, 255, 0.05);
	border-bottom: 1px solid rgba(255, 255, 255, 0.05);
`;

const StyledHeadLeftContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		opacity: 0.75;
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.75;
	}
`;

const StyledTag = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 20px;
	padding: 0 5px;
	border-radius: 5px;
	transition: background-color 0.3s ease;

	${Text} {
		font-weight: 500;
		font-size: 12px;
		transition: color 0.3s ease;
	}
`;

const StyledStatusTag = styled(StyledTag)`
	&.${ReportState.CLOSED} {
		background: rgba(255, 255, 255, 0.1);

		${Text} {
			color: rgba(255, 255, 255, 0.5);
		}
	}

	&.${ReportState.COMPLETED} {
		background: #1f8034;

		${Text} {
			color: #ffffff;
		}
	}

	&.${ReportState.ACTIVE} {
		background: #fabe2c;

		${Text} {
			color: #000000;
		}
	}
`;

const StyledHelpTag = styled(StyledTag)`
	background: #c71e1e;

	${Text} {
		color: #ffffff;
	}
`;

const StyledPendingTag = styled(StyledTag)`
	background: rgba(255, 255, 255, 0.1);

	${Text} {
		color: rgba(255, 255, 255, 0.25);
	}
`;

const StyledDateTimeTag = styled(StyledTag)`
	gap: 10px;
	background: rgba(255, 255, 255, 0.1);

	${Text} {
		color: #ffffff;

		&.date {
			opacity: 0.5;
		}
	}
`;

const StyledHeadRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledMessagesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0;
	height: 748px;
	overflow-y: scroll;
	padding: 40px 20px 0;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledInputContainer = styled.div<{ $hidden?: boolean }>`
	position: absolute;
	bottom: 20px;
	left: 20px;
	display: grid;
	grid-template-columns: 1fr auto;
	align-items: center;
	gap: 10px;
	width: calc(100% - 40px);
	height: 60px;
	padding: 0 10px 0 0;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	${({ $hidden }) =>
		$hidden &&
		css`
			display: none;
		`}
`;

const StyledInput = styled.input`
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;
	border: none;
	outline: none;
	background-color: transparent;
	height: 58px;
	padding: 0 0 0 20px;

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
	}
`;

const StyledLoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 360px;

	${Text} {
		font-weight: 400;
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledEmptyContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 441px;

	${Text} {
		font-weight: 400;
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledAdminEmptyContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 27px;
	margin-top: 414px;

	${Text} {
		font-weight: 400;
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		opacity: 0.25;
	}
`;

const StyledAdminButtonsContainer = styled.div`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
	width: 500px;
	margin-top: 20px;

	button {
		width: fit-content;
	}
`;

const StyledPlayerButtonsContainer = styled.div`
	display: flex;
	gap: 10px;
	justify-content: flex-end;
	margin-top: 20px;
	margin-left: auto;

	button {
		width: fit-content;
	}
`;

export {
	StyledAdminButtonsContainer,
	StyledAdminEmptyContainer,
	StyledContainer,
	StyledDateTimeTag,
	StyledEmptyContainer,
	StyledHeadContainer,
	StyledHeadLeftContainer,
	StyledHeadRightContainer,
	StyledHelpTag,
	StyledInput,
	StyledInputContainer,
	StyledLoadingContainer,
	StyledMessagesContainer,
	StyledPendingTag,
	StyledPlayerButtonsContainer,
	StyledStatusTag,
	StyledTag,
};
